import React, { Component } from 'react';
import '../App.css';
import LayoutComponent from './LayoutComponent';

class App extends Component {
  render() {
    return (
        <LayoutComponent />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js